<script setup>
const config = useRuntimeConfig();
const baseURL = config.public.baseUrl;
const { data } = await useFetch(`${baseURL}/content/products-content.json`);

useHead({
  title: data.value?.meta_tags?.title || "",
  meta: data.value?.meta_tags?.meta || [],
});
</script>

<template>
  <section class="max-w-screen-xl mx-auto px-4 text-center pb-16">
    <NuxtImg
      src="/images/product-hero.webp"
      alt="industry"
      width="90"
      height="108"
      class="mx-auto"
      loading="eager"
      format="webp"
    />
    <h1>
      <WrGradientText
        >Some of our <br />
        Hot & Steamy Products
      </WrGradientText>
    </h1>
    <p class="tracking-[0.5px] text-lg text-center">
      {{ data?.header?.subtitle }}
    </p>
  </section>

  <section class="py-10 lg:py-20">
    <div class="grid md:grid-cols-2 items-start max-w-screen-xl mx-auto px-4">
      <NuxtImg
        src="/images/product-left.webp"
        alt="product-hero"
        width="528"
        height="370"
        loading="lazy"
        format="webp"
      />

      <div class="text-left">
        <h2>
          <WrGradientText>{{ data?.product_intro?.title }}</WrGradientText>
        </h2>
        <p class="!leading-[1.8] tracking-[0.5px] mb-4">
          {{ data?.product_intro?.subtitle }}
        </p>
        <p class="!leading-[1.8] tracking-[0.5px]">
          Looking out for a helping hand? You’ll have one very soon...
        </p>
      </div>
    </div>
  </section>

  <WrBannerCTA
    heading="Have an Idea?"
    paragraph-text="Let's have a discussion!"
    button-text="Contact Us"
  />

  <section class="px-4 py-16 max-w-screen-xl mx-auto">
    <h2 class="text-center">
      <WrGradientText> Open Source Packages </WrGradientText>
    </h2>
    <p class="text-lg text-center mb-10">
      Have a look around! we’re pretty sure there’s something here that will
      suit your project!
    </p>

    <div class="space-y-6">
      <div
        v-for="(pkg, index) in data?.packages?.lists"
        :key="index"
        class="grid md:grid-cols-3 items-center justify-between gap-4 bg-white rounded-xl p-6 shadow-[0_0_0_1px_#E4E2ED] hover:[box-shadow:0_.0625rem_.75rem_0_rgba(38,57,82,.2)] dark:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.5)] dark:hover:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.8)] dark:bg-transparent [box-shadow:0_.3em_.3em_-.3em_hsla(0,0%,4%,.1),_0_0_0_.1rem_hsla(0,0%,4%,.08)] transition-all duration-500"
      >
        <div
          class="flex md:items-center max-md:flex-col items-start gap-4 w-full"
        >
          <!-- Initial Icon -->
          <div
            class="bg-[#ffe3e3] text-[#cc0f35] font-bold rounded-full w-12 h-12 flex items-center justify-center text-xl"
          >
            {{ pkg.initial }}
          </div>

          <!-- Content -->
          <NuxtLink :to="pkg.link" class="block">
            <h3 class="text-lg font-bold text-[#5e2ca5] dark:text-white">
              {{ pkg.title }}
            </h3>
            <span
              class="inline-block text-xs bg-[#e6f1ff] dark:bg-[linear-gradient(92.4deg,#270945_6.22%,#4C127F_93.78%)] text-[#5e2ca5] dark:text-white px-2 py-1 rounded-full mt-1"
            >
              {{ pkg.language }}
            </span>
          </NuxtLink>
        </div>
        <div>
          <p class="text-sm font-semibold text-[#312852] dark:text-[#FFF]">
            {{ pkg.description }}
          </p>

          <div
            class="flex flex-wrap text-sm mt-2 text-[#5e2ca5] dark:text-white gap-2"
          >
            <template v-for="(tag, i) in pkg.tags" :key="i">
              <span>{{ tag }}</span>
              <span v-if="i < pkg.tags.length - 1">|</span>
            </template>
          </div>
        </div>

        <!-- View Repo Button -->
        <WrButton :link="pkg.link" container-class="md:ml-auto" target="_blank">
          View Repo
        </WrButton>
      </div>
    </div>
  </section>

  <section class="mt-4 relative z-10 max-w-screen-xl mx-auto px-4">
    <h2 class="text-center">
      <WrGradientText text="Trusted for excellence and efficiency" />
      <p class="text-lg text-[var(--foreground)]">
        Webreinvent is trusted by leading organisations to enhance their
        development and operational efficiency.
      </p>
    </h2>
    <WrTestimonialCardCarousel class="mt-12" />
    <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-7"
      >View All</WrButton
    >
  </section>
</template>
